import React, { useContext, useEffect, useState } from "react";
import { Badge, Button, Container, Form, Modal, Table } from "react-bootstrap";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const FakeApi = () => {
  const Navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [allUsers, setAllUsers] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const [productId, setProductId] = useState(0);
  const [productTitle, setProductTitle] = useState("");
  const [productPrice, setProductPrice] = useState(0.0);
  const [productDescription, setProductDescription] = useState("");
  const [productActionLabel, setProductActionLabel] = useState("ADD PRODUCT");
  const [productCategoryLabel, setProductCategoryLabel] =
    useState("Select Categories");
  const [productCategory, setProductCategory] = useState("");
  const [productImage, setProductImage] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSoIv09JTxD9sg1RJeqk-G_4qKFvyavklro8g&s"
  );

  const getAllUsers = () => {
    axios
      .get(`${baseUrl}/users`)
      .then((response) => {
        setAllUsers(response.data);
        console.log(response.data);
      })
      .catch();
  };

  const addNewProduct = (
    pid,
    ptitle,
    pprice,
    pdescription,
    pcategory,
    pimage
  ) => {
    axios
      .post(`${baseUrl}/products`, {
        id: pid,
        title: ptitle,
        price: pprice,
        description: pdescription,
        category: pcategory,
        image: pimage,
      })
      .then((response) => {
        if (response.data != null) {
          Swal.fire({
            title: "Congratulations!",
            text: "Product added successfully.",
            icon: "success",
            confirmButtonText: "Cool",
          });
          getAllUsers();
        } else {
          Swal.fire({
            title: "Oops!",
            text: "Product cannot be added yet.",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }

        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const updateProduct = (
    pid,
    ptitle,
    pprice,
    pdescription,
    pcategory,
    pimage
  ) => {
    axios
      .put(`${baseUrl}/products/${pid}`, {
        id: pid,
        title: ptitle,
        price: pprice,
        description: pdescription,
        category: pcategory,
        image: pimage,
      })
      .then((response) => {
        if (response.data != null) {
          Swal.fire({
            title: "Congratulations!",
            text: "Product updated successfully.",
            icon: "success",
            confirmButtonText: "Cool",
          });
          getAllUsers();
        } else {
          Swal.fire({
            title: "Oops!",
            text: "Product cannot be updated yet.",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch();
  };

  const deleteProduct = (pid) => {
    axios
      .delete(`${baseUrl}/products/${pid}`)
      .then((response) => {
        if (response.data != null) {
          Swal.fire({
            title: "Congratulations!",
            text: "Product deleted successfully.",
            icon: "success",
            confirmButtonText: "Cool",
          });
          getAllUsers();
        } else {
          Swal.fire({
            title: "Oops!",
            text: "Product cannot be deleted yet.",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <>
      <Modal
        show={modalShow}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add New Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <Container>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Product Id</Form.Label>
                <Form.Control
                  value={productId}
                  onChange={(event) => {
                    setProductId(event.target.value);
                  }}
                  type="number"
                  placeholder={productId}
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Product Title</Form.Label>
                <Form.Control
                  value={productTitle}
                  onChange={(event) => {
                    setProductTitle(event.target.value);
                  }}
                  type="text"
                  placeholder={"product title"}
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Product Price</Form.Label>
                <Form.Control
                  value={productPrice}
                  onChange={(event) => {
                    setProductPrice(event.target.value);
                  }}
                  type="number"
                  placeholder={"product price"}
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Product Description</Form.Label>
                <Form.Control
                  value={productDescription}
                  onChange={(event) => {
                    setProductDescription(event.target.value);
                  }}
                  as="textarea"
                  rows={3}
                  placeholder={"product description"}
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Product Category</Form.Label>
                <Form.Select
                  onChange={(event) => {
                    setProductCategory(event.target.value);
                  }}
                  aria-label="Default select example"
                >
                  <option>{productCategoryLabel}</option>
                  <option value="1">Category 1</option>
                  <option value="2">Category 2</option>
                  <option value="3">Category 3</option>
                </Form.Select>
              </Form.Group>
              <Button
                onClick={() => {
                  if (productActionLabel == "ADD PRODUCT") {
                    addNewProduct(
                      productId,
                      productTitle,
                      productPrice,
                      productDescription,
                      productCategory,
                      productImage
                    );
                    /*                     setAllUsers(prevArray => [...prevArray, addNewProduct]);
                     */
                  } else {
                    updateProduct(
                      productId,
                      productTitle,
                      productPrice,
                      productDescription,
                      productCategory,
                      productImage
                    );
                  }
                }}
              >
                {productActionLabel}
              </Button>
            </Form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModalShow(false);
              setProductActionLabel("ADD PRODUCT");
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex justify-content-between align-items-center mt-5">
        <Button variant="primary" onClick={() => setModalShow(true)}>
          Add New Product
        </Button>
        <h1
          style={{ cursor: "pointer" }}
          onClick={() => {
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            Navigate("/login");
          }}
        >
          LOGOUT
        </h1>
      </div>
      <Table responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>User Name</th>
            <th>Password</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          {allUsers.map((item) => {
            return (
              <tr>
                <td>{item.id}</td>
                <td>{item.email}</td>
                <td>{item.username}</td>
                <td>{item.password}</td>
                <td>
                  <Badge
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      window.open(
                        `https://maps.google.com?q=${item.address.geolocation.lat},${item.address.geolocation.long}`
                      );
                    }}
                    bg="danger"
                  >
                    {item.address.street}, {item.address.zipcode},{" "}
                    {item.address.city}
                  </Badge>
                </td>
                <td>
                  <Button
                    onClick={() => {
                      setProductActionLabel("UPDATE PRODUCT");
                      console.log(item);
                      setProductId(item.id);
                      setProductTitle(item.title);
                      setProductPrice(item.price);
                      setProductDescription(item.description);
                      setProductCategoryLabel(item.category);
                      setModalShow(true);
                    }}
                    className="btn btn-warning mt-2"
                  >
                    EDIT
                  </Button>
                  <Button
                    onClick={() => {
                      deleteProduct(item.id);
                    }}
                    className="btn btn-danger mt-2"
                  >
                    DELETE
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};
export default FakeApi;
